<template>
    <div class="card card-custom card-stretch gutter-b d-flex">
        <div class="form_forgot-password">
            <el-container>
                <el-main>
                    <div class="header-form__forgot-password">
                        <div class="title">
                            <span class="text-dr" v-if="!submitForm">
                                パスワード再設定
                            </span>
                            <span class="text-dr" v-if="submitForm">
                               パスワード再設定完了
                            </span>
                        </div>
                    </div>
                    <div class="pl-20 pr-20 mt-3">

                         <el-card class="box-card p-custom">
                             <div class="mb-15">
                                 <h4 class="text-center" v-if="queryParam.flag">
                                     <b>現行のパスワードは84日で期限がきれしましたので、パスワードを再設定ください。</b>
                                 </h4>
                             </div>
                            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="top"
                                     class="demo-ruleForm demo-form" v-if="!submitForm">
<!--                                <el-form-item prop="password">
                                    <h5 class="text-dr font-w">新しいパスワード</h5>
                                    <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
                                </el-form-item>
                                <div class="pb-5"><p>※10文字以上半角英数記号のみ</p></div>-->

                                <div class="row mb-8">
                                    <div class="col-md-3">
                                        <h6 class="mt-3"><b>新規のパスワード</b></h6>
                                    </div>
                                    <el-form-item prop="password" class="col-md-9">
                                        <el-input type="password" class="bg-gray-item" v-model="ruleForm.password">
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="row mb-8">
                                    <div class="col-md-3">
                                        <h6 class="mt-3"><b>パスワード再入力</b></h6>
                                    </div>
                                    <el-form-item prop="password_confirmation" class="col-md-9">
                                        <el-input type="password" class="bg-gray-item" v-model="ruleForm.password_confirmation">
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="d-flex justify-content-center mt-0">
                                    <el-button class="btn-custom" type="" @click="$router.push('login')">
                                        キャンセル
                                    </el-button>
                                    <el-button class="btn-custom" type="primary" @click="onSubmit">
                                        確定
                                    </el-button>
                                </div>
                                <input type="hidden" name="_csrf" v-model="ruleForm._csrf" />
                            </el-form>
                            <div v-if="submitForm" class="pl-20 pr-20">
                                <h5 class="text-center">パスワード再設定が完了しました。</h5>

                                <div class="d-flex justify-content-center mt-20">
                                    <el-button class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3" type="primary" @click="$router.push('login')">ログインへ</el-button>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </el-main>
            </el-container>
        </div>
      <my-dialog
        v-on:submit="popup=false"
        v-bind:dialog="popup"
        :closeOnClickModal="false" width="20%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')"
        :showCancelButton="false">
        <template slot="header">
          <div class="textwidget text-center">
            {{ contentPoopup }}
          </div>
        </template>
      </my-dialog>
    </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import {CALL_CSRF_TOKEN, getCsrfRandom} from "@/core/services/store/auth.module";

export default {
    name: "ResetPassword",
    data() {
        var validatePass = (rule, value, callback) => {
            var regex = new RegExp(/^[a-zA-Z0-9#?!@$%^&*-]*$/);
            var regex1 = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,12}$/);
            var regexNoSpaceInside = new RegExp(/^[\S]+$/);
            if(!regexNoSpaceInside.test(value)){
                callback(new Error('空白以外を入力してください。'));
            } else if (!regex1.test(value) || !regex.test(value)) {
                callback(new Error('6文字以上12以内半角英数記号のみを入力してください。'));
            }  else {
                setTimeout(() => {
                    if (this.ruleForm.password !== '') {
                        this.$refs.ruleForm.validateField('password');
                    }
                    callback();
                }, 1000);

            }
        };
        var validatePasswordConfirmation = (rule, value, callback) => {
            if (this.ruleForm.password !== this.ruleForm.password_confirmation) {
                callback(new Error('「パスワード」 と 「パスワード（再入力）」 が一致しません。'));
            } else {
                setTimeout(() => {
                    if (this.ruleForm.password_confirmation !== '') {
                        this.$refs.ruleForm.validateField('password_confirmation');
                    }
                    callback();
                }, 1000);

            }
        }
        return {
            ruleForm: {
                code: '',
                password: '',
                password_confirmation : '',
                _csrf:''
            },
          popup:false,
          contentPoopup:'',
            rules: {
            /*    password: [
                    {required: true, message: 'パスワードを入力してください。', trigger: 'blur'},
                    // { validator: validatePass, trigger: 'blur' }
                ],
                password_confirmation : [
                    {required: true, message: '念のためパスワードを再入力してください', trigger: 'blur'},
                    // { validator: validatePasswordConfirmation, trigger: 'blur' }
                ],*/

            },
            submitForm: false
        }
    },
    computed: {
        queryParam() {
            return this.$route.query
        }
    },
  created() {
    this.ruleForm._csrf = getCsrfRandom()
        this.getDataFromQuery();
    },
  mounted() {
    const vm = this
    this.$store.dispatch(CALL_CSRF_TOKEN);
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        vm.onSubmit()
      }
    });
  },
    methods: {
        getDataFromQuery() {
            this.ruleForm.token = this.queryParam.token ? this.queryParam.token : '';
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.turnOffErrorMessage('ruleForm')
                    let data = JSON.parse(JSON.stringify(this.ruleForm));
                    apiService.post(`auth/reset-password`, data).then(data => {
                        if (data && data.data && data.data.success) {
                            this.submitForm = true
                        }else if (data.data.code = 422){
                            if (data.data && data.data.data && data.data.data.token&& data.data.data.token[0]){
                                this.popup = true
                                this.contentPoopup = data.data.data.token[0]
                            }else {
                                this.showErrorMessage(data.data.data, 'ruleForm')
                            }
                        }else {
                            this.notifyError('error server')
                        }
                    }).catch(e => {
                        this.loading = false
                        this.notifyError(e)
                    })
                }
            })
/*
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.turnOffErrorMessage('ruleForm')
                    let data = JSON.parse(JSON.stringify(this.ruleForm));
                    apiService.post(`auth/reset-password`, data).then(data => {
                        if (data && data.data && data.data.success) {
                            this.submitForm = true
                        }else if (data.data.code = 422){
                          if (data.data && data.data.data && data.data.data.token&& data.data.data.token[0]){
                            this.popup = true
                            this.contentPoopup = data.data.data.token[0]
                          }else {
                            this.showErrorMessage(data.data.data, 'ruleForm')
                          }
                        }else {
                            this.notifyError('error server')
                        }
                    }).catch(e => {
                        this.loading = false
                        this.notifyError(e)
                    })
                }
            });*/
        }
    }
}
</script>

<style scoped>
.form_forgot-password {
    width: 90%;
    margin: 0 auto;
}
.header-form__forgot-password .title {
    text-align: center;
    padding: 4px 0;
    font-size: 23px;
    font-weight: bold;
}
.header-form__forgot-password .logo {
    background: #40659d;
    padding: 15px;
}
.text-dr{
  color: #181C32 !important;;
}
.font-w {
  font-weight: 600;
}
.submit-form{
  font-size: 18px;
  font-weight: bold;
}
.p-custom {
    padding: 58px 24px 0px 24px;
}
</style>
